<template>
    <AppLayout>
        <div class="container p-4 mx-auto md:px-1 md:py-4">
            <!-- breadcrumb -->
            <nav class="mb-6 text-sm font-semibold" aria-label="Breadcrumb">
                <ol class="inline-flex p-0 list-none">
                    <li class="flex items-center text-blue-500">
                        <inertia-link :href="route('landing')" class="text-gray-600">
                            {{ $t('LBL_HOME') }}
                        </inertia-link>
                        <svg fill="#34D399" class="w-3 h-3 mx-3 " xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 320 512">
                            <path
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
                        </svg>
                    </li>
                    <li class="flex items-center">
                        <a href="#" class="text-gray-600">
                            {{ $t('LBL_USER') }}
                        </a>
                    </li>
                </ol>
            </nav>
            <!-- breadcrumb end -->

            <!-- <div class="p-0 max-w-full bg-white rounded border shadow-md sm:p-0 dark:bg-gray-800 dark:border-gray-700">
                <div class="flex items-center justify-between p-2">
                    <div class="p-0">
                        <label for="table-search" class="sr-only">Search</label>
                        <div class="relative mt-1">
                            <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                                <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                                    viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd"
                                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <t-input id="user-search-box" v-model="search" type="text" variant="success"
                                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded focus:ring-green-500 focus:border-green-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                                placeholder="Search for user" @keypress.enter="fetchPageData()" />
                        </div>
                    </div> -->
            <div
                class="w-full bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
                <!-- Search & Action Bar -->
                <div class="flex flex-wrap items-center justify-between gap-4 p-4 sm:flex-nowrap">
                    <!-- Search Box -->
                    <div class="relative w-full sm:w-auto">
                        <label for="table-search" class="sr-only">Search</label>
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                                viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                        <t-input id="user-search-box" v-model="search" type="text" variant="success"
                            class="w-full sm:w-80 pl-10 pr-4 py-2.5 text-sm rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:outline-none dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                            placeholder="Search for user" @keypress.enter="fetchPageData()" />
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex flex-wrap gap-2">
                        <t-button v-if="isSuperAdmin" @click="toggleRightSidebar('admin')">
                            Add Admin
                        </t-button>
                        <t-button v-if="isWholesaler" variant="success" @click="toggleRightSidebar('salesperson')">
                            Add Sales Person
                        </t-button>
                        <t-button v-if="isSuperAdmin" @click="goto('kyc.create')">
                            Add Wholesaler
                        </t-button>
                    </div>
                </div>

                <!-- <t-table :responsive="true" :responsive-breakpoint="640"
                    :headers="['#', 'NAME', 'EMAIL', 'ROLE', 'CREATED', 'STATUS', 'ACTIONS']" :data="users.data"
                    class="text-xs md:text-sm border-none shadow-none"> -->
                <!-- Table -->
                <t-table :responsive="true" :responsive-breakpoint="640"
                    :headers="['#', 'Name', 'Email', 'Role', 'Created', 'Status', 'Actions']" :data="users.data"
                    class="min-w-full text-sm text-left text-gray-700 dark:text-gray-300 border-none shadow-none">

                    <!-- <template slot="tbody"
                        slot-scope="{ tbodyClass, trClass, tdClass, renderResponsive, data, headers }">
                        <template v-if="renderResponsive">
                            <tbody v-for="(row, rowIndex) in data" :key="rowIndex"
                                :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-100' : '']">
                                <tr v-for="header in headers" :key="header.text"
                                    :class="[trClass, rowIndex % 2 == 0 ? 'bg-gray-100' : 'bg-white']">
                                    <th class="pl-1 text-sm font-semibold text-left text-gray-600 uppercase">
                                        {{ header.text }}
                                    </th>

                                    <td :class="[tdClass, 'relative']">
                                        <div v-if="header.text === '#'">
                                            {{ rowIndex + 1 + (currentPage - 1) * perPage }}
                                        </div>

                                        <div v-if="header.text === 'NAME'">
                                            {{ row.name }}
                                        </div>

                                        <div v-if="header.text === 'EMAIL'">
                                            {{ (row.email && row.email.name) || 'No Email' }}
                                        </div>

                                        <div v-if="header.text === 'ROLE'">
                                            {{ row.roles[0].name }}
                                        </div>

                                        <div v-if="header.text === 'CREATED'">
                                            {{ row.created_at | fromNow }}
                                        </div>

                                        <div v-if="header.text === 'STATUS'">
                                            {{ row.deleted_at ? 'Suspended' : 'Active' }}
                                        </div>

                                        <div v-if="header.text === 'ACTIONS'" class="flex flex-wrap items-center gap-1">
                                            <div v-if="row.id === $page.props.user.id">
                                                Self
                                            </div>
                                            <t-button v-else-if="
                                                isSuperAdmin &&
                                                !!row.roles.find(
                                                    role => role.name === 'superadmin' || role.name === 'admin',
                                                )
                                            " variant="success" @click="toggleRole(row)">
                                                Change role to
                                                {{
                                                    row.roles.find(role => role.name === 'superadmin')
                                                        ? 'admin'
                                                        : 'superadmin'
                                                }}
                                            </t-button>
                                            <t-button v-else-if="!row.deleted_at" variant="success"
                                                @click="suspendUser(row)">
                                                Suspend
                                            </t-button>

                                            <t-button v-else variant="error" @click="unsuspendUser(row)">
                                                Activate
                                            </t-button>

                                            <t-button
                                                v-if="!row.deleted_at && !!row.roles.find(role => role.name === 'salesperson')"
                                                variant="success" @click="showAssignRetailersModal(row)">
                                                Assign Retailers
                                            </t-button>

                                            <t-button
                                                v-if="!row.deleted_at && !!row.roles.find(role => role.name === 'salesperson')"
                                                variant="success" @click="showSalesPersonDetail(row)">
                                                View Report
                                            </t-button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
</template> -->

                    <!-- Responsive View -->
                    <template slot="tbody"
                        slot-scope="{ tbodyClass, trClass, tdClass, renderResponsive, data, headers }">
                        <template v-if="renderResponsive">
                            <tbody v-for="(row, rowIndex) in data" :key="rowIndex"
                                :class="[tbodyClass, 'bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700']">
                                <tr v-for="header in headers" :key="header.text"
                                    class="hover:bg-gray-100 dark:hover:bg-gray-700 transition duration-200">
                                    <th class="pl-1 text-xs font-semibold text-left text-gray-600 uppercase">
                                        {{ header.text }}
                                    </th>
                                    <td :class="[tdClass, 'py-2']">
                                        <div v-if="header.text === '#'">
                                            {{ rowIndex + 1 + (currentPage - 1) * perPage }}
                                        </div>
                                        <div v-else-if="header.text === 'NAME'">
                                            {{ row.name }}
                                        </div>
                                        <div v-else-if="header.text === 'EMAIL'">
                                            {{ (row.email && row.email.name) || 'No Email' }}
                                        </div>
                                        <div v-else-if="header.text === 'ROLE'">
                                            {{ row.roles[0].name }}
                                        </div>
                                        <div v-else-if="header.text === 'CREATED'">
                                            {{ row.created_at | fromNow }}
                                        </div>
                                        <div v-else-if="header.text === 'STATUS'">
                                            {{ row.deleted_at ? 'Suspended' : 'Active' }}
                                        </div>
                                        <div v-else-if="header.text === 'ACTIONS'">
                                            <div class="flex flex-col gap-1 sm:flex-row sm:flex-wrap">
                                                <span v-if="row.id === $page.props.user.id">Self</span>

                                                <t-button
                                                    v-else-if="isSuperAdmin &&
                                                        !!row.roles.find(role => role.name === 'superadmin' || role.name === 'admin')"
                                                    variant="success" @click="toggleRole(row)">
                                                    Change role to {{row.roles.find(role => role.name === 'superadmin')
                                                        ? 'admin' : 'superadmin'}}
                                                </t-button>

                                                <t-button v-else-if="!row.deleted_at" variant="success"
                                                    @click="suspendUser(row)">
                                                    Suspend
                                                </t-button>

                                                <t-button v-else variant="error" @click="unsuspendUser(row)">
                                                    Activate
                                                </t-button>

                                                <t-button
                                                    v-if="!row.deleted_at && row.roles.find(role => role.name === 'salesperson')"
                                                    variant="success" @click="showAssignRetailersModal(row)">
                                                    Assign Retailers
                                                </t-button>

                                                <t-button
                                                    v-if="!row.deleted_at && row.roles.find(role => role.name === 'salesperson')"
                                                    variant="success" @click="showSalesPersonDetail(row)">
                                                    View Report
                                                </t-button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </template>

                    <!-- <template slot="row" slot-scope="{ trClass, tdClass, row, rowIndex }">
                        <tr
                            :class="[trClass, rowIndex % 2 == 0 ? '' : 'bg-gray-50 dark:bg-gray-800', 'text-xs md:text-base']">
                            <td :class="[tdClass]">
                                {{ rowIndex + 1 + (currentPage - 1) * perPage }}
                            </td>
                            <td :class="[tdClass]">
                                {{ row.name }}
                            </td>
                            <td :class="[tdClass]">
                                {{ row.email }}
                            </td>
                            <td :class="[tdClass]">
                                {{ row.roles[0].name }}
                            </td>
                            <td :class="[tdClass]">
                                {{ row.created_at | fromNow }}
                            </td>
                            <td :class="[tdClass]">
                                {{ row.deleted_at ? 'Suspended' : 'Active' }}
                            </td>
                            <td :class="[tdClass]">
                                <div v-if="row.id === $page.props.user.id">
                                    Self
                                </div>
                                <div v-else-if="
                                    isSuperAdmin &&
                                    !!row.roles.find(
                                        role => role.name === 'superadmin' || role.name === 'admin',
                                    )
                                " class="my-2">
                                    <t-button variant="success" @click="toggleRole(row)">
                                        Change role to
                                        {{row.roles.find(role => role.name === 'superadmin') ? 'admin' : 'superadmin'
                                        }}
                                    </t-button>
                                </div>
                                <div v-else-if="!row.deleted_at" class="my-2">
                                    <t-button variant="success" @click="suspendUser(row)">
                                        Suspend
                                    </t-button>
                                </div>

                                <div v-else class="my-2">
                                    <t-button variant="error" @click="unsuspendUser(row)">
                                        Activate
                                    </t-button>
                                </div>

                                <div v-if="!row.deleted_at && !!row.roles.find(role => role.name === 'salesperson')"
                                    class="my-2">
                                    <t-button variant="success" @click="showAssignRetailersModal(row)">
                                        Assign Retailers
                                    </t-button>
                                </div>

                                <div v-if="!row.deleted_at && !!row.roles.find(role => role.name === 'salesperson')"
                                    class="my-2">
                                    <t-button variant="success" @click="showSalesPersonDetail(row)">
                                        View Report
                                    </t-button>
                                </div>
                            </td>
                        </tr>
                    </template> -->

                    <!-- Desktop View -->
                    <template slot="row" slot-scope="{ trClass, tdClass, row, rowIndex }">
                        <tr
                            :class="[trClass, 'border-b border-gray-200 leading-10 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition duration-200']">
                            <td :class="[tdClass, 'py-3']">
                                {{ rowIndex + 1 + (currentPage - 1) * perPage }}
                            </td>
                            <td :class="[tdClass]">
                                <div v-if="row.id === $page.props.user.id"
                                    class="relative inline-flex rounded-sm border border-green-300 bg-green-50 overflow-hidden text-green-600 text-sm font-medium shadow-sm px-2 py-1">
                                    {{ row.name }}
                                </div>
                                <div v-else>{{ row.name }}</div>
                            </td>
                            <td :class="[tdClass]">{{ row.email }}</td>
                            <td :class="[tdClass]">{{ row.roles[0].name }}</td>
                            <td :class="[tdClass]">{{ row.created_at | fromNow }}</td>
                            <td :class="[tdClass]">{{ row.deleted_at ? 'Suspended' : 'Active' }}</td>
                            <td :class="[tdClass]">
                                <div class="relative inline-flex shadow-sm rounded-md overflow-hidden">
                                    <!-- Primary Action -->
                                    <div v-if="row.id === $page.props.user.id">
                                        <span
                                            class="rounded-sm border border-green-300 bg-green-50 overflow-hidden text-green-600 text-sm px-6 py-1">
                                            Self
                                        </span>
                                    </div>

                                    <div
                                        v-else-if="isSuperAdmin && !!row.roles.find(role => role.name === 'superadmin' || role.name === 'admin')">
                                        <t-button variant="success" size="xs" class="rounded-none rounded-l-md"
                                            @click="toggleRole(row)">
                                            Change Role
                                        </t-button>
                                    </div>

                                    <div v-else-if="!row.deleted_at">
                                        <t-button variant="success" size="xs" class="rounded-none rounded-l-md"
                                            @click="suspendUser(row)">
                                            Suspend
                                        </t-button>
                                    </div>

                                    <div v-else>
                                        <t-button variant="error" size="xs" class="rounded-none rounded-l-md"
                                            @click="unsuspendUser(row)">
                                            Activate
                                        </t-button>
                                    </div>

                                    <!-- Dropdown Toggle Button -->
                                    <div v-if="!row.deleted_at && row.roles.find(role => role.name === 'salesperson')"
                                        class="relative">
                                        <t-button variant="secondary" size="xs" class="rounded-none rounded-r-md"
                                            @click.stop="toggleDropdown(row.id)">
                                            ...
                                        </t-button>

                                        <!-- Dropdown Menu -->
                                        <div v-if="activeDropdownId === row.id"
                                            class="absolute right-0 mt-2 w-44 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50">
                                            <ul class="text-sm text-gray-700 dark:text-gray-200">
                                                <li>
                                                    <button @click="showAssignRetailersModal(row)"
                                                        class="block w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-left">
                                                        Assign Retailers
                                                    </button>
                                                </li>
                                                <li>
                                                    <button @click="showSalesPersonDetail(row)"
                                                        class="block w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 text-left">
                                                        View Report
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </td>


                            <!-- <td :class="[tdClass]">
                                <div class="relative inline-flex rounded-full border border-indigo-300 bg-indigo-50 overflow-hidden text-indigo-600 text-sm font-medium shadow-sm">
                                    
                                    <button v-if="row.id === $page.props.user.id"
                                        class="flex items-center gap-2 px-4 py-2 hover:bg-indigo-100 transition">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2"
                                            viewBox="0 0 24 24">
                                            <path d="M9 5l7 7-7 7" />
                                        </svg>
                                        Self
                                    </button>
                                    <button
                                        v-else-if="isSuperAdmin && !!row.roles.find(role => ['superadmin', 'admin'].includes(role.name))"
                                        class="flex items-center gap-2 px-4 py-2 hover:bg-indigo-100 transition"
                                        @click="toggleRole(row)">
                                        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2"
                                            viewBox="0 0 24 24">
                                            <path d="M9 5l7 7-7 7" />
                                        </svg>
                                        Change Role
                                    </button>

                                    <div class="relative" :ref="'dropdown-container-' + row.id">
                                        <t-button @click.stop="toggleDropdown(row.id)">
                                            ...
                                        </t-button>

                                        <div v-if="activeDropdownId === row.id"
                                            class="absolute z-50 mt-2 right-0 w-48 bg-white border rounded-md shadow-lg text-sm">
                                            <ul class="py-1 text-gray-700">
                                                <li v-if="row.id === $page.props.user.id" class="px-4 py-2">Self</li>

                                                <li v-else-if="isSuperAdmin && row.roles.find(role => ['superadmin', 'admin'].includes(role.name))"
                                                    class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    @click="toggleRole(row)">
                                                    Change role to {{row.roles.find(role => role.name === 'superadmin')
                                                        ?
                                                        'admin' : 'superadmin'}}
                                                </li>

                                                <li v-else-if="!row.deleted_at"
                                                    class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    @click="suspendUser(row)">
                                                    Suspend
                                                </li>

                                                <li v-else class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    @click="unsuspendUser(row)">
                                                    Activate
                                                </li>

                                                <li v-if="!row.deleted_at && row.roles.find(role => role.name === 'salesperson')"
                                                    class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    @click="showAssignRetailersModal(row)">
                                                    Assign Retailers
                                                </li>

                                                <li v-if="!row.deleted_at && row.roles.find(role => role.name === 'salesperson')"
                                                    class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    @click="showSalesPersonDetail(row)">
                                                    View Report
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </td> -->
                        </tr>
                    </template>
                </t-table>

                <!-- <div v-if="!users.data.length" class="my-10 w-100 text-center">
                    {{ $t('LBL_DATA_FOUND') }}
                </div> -->

                <!-- Empty State -->
                <div v-if="!users.data.length" class="text-center text-gray-500 dark:text-gray-400 py-12">
                    {{ $t('LBL_DATA_FOUND') }}
                </div>

                <!-- <div class="py-2 bg-gray-100">
                    <t-pagination v-if="users.data.length" v-model="currentPage" :total-items="totalRows"
                        :per-page="perPage" :limit="limit" :disabled="!users.data.length" @change="fetchPageData" />
                </div> -->

                <div
                    class="flex justify-center items-center bg-gray-100 dark:bg-gray-800 px-4 py-4 border-t dark:border-gray-700">
                    <t-pagination v-if="users.data.length" v-model="currentPage" :total-items="totalRows"
                        :per-page="perPage" :limit="limit" :disabled="!users.data.length" @change="fetchPageData" />
                </div>
            </div>
        </div>

        <t-modal v-model="retailerAssignModal" header="Assign Retailers to your Salesperson">
            <div>
                <div v-if="currentSalesperson">
                    Salesperson: {{ currentSalesperson.name }}
                </div>
                <div>
                    <Multiselect v-model="selectedRetailers" :options="selectableRetailersForCurrentSalesPerson()"
                        :multiple="true" :close-on-select="false" placeholder="Pick Retailers" label="name"
                        track-by="name" />
                </div>
            </div>
            <template #footer>
                <div class="flex justify-between">
                    <t-button type="button" @click="hideAssignRetailersModal">
                        Cancel
                    </t-button>
                    <t-button type="button" @click="assignRetailers">
                        Assign
                    </t-button>
                </div>
            </template>
        </t-modal>

        <RightSidebar :is-open="rightSidebar" :component-name="rightSidebarComponentName"
            @closeRightSidebar="toggleRightSidebar">
            <template #heading>
                <div class="relative mt-4 ">
                    <div class="text-xl font-bold absolute left-0">
                        {{ sidebarTitle }}
                    </div>
                    <div class="text-md text-right cursor-pointer absolute right-0" @click="rightSidebar = false">
                        close
                    </div>
                </div>
            </template>
        </RightSidebar>
    </AppLayout>
</template>

<script>
import _ from 'lodash';
import Multiselect from 'vue-multiselect';
import AppLayout from '@/Layouts/AppLayout.vue';
import RightSidebar from '@/Components/RightSidebar.vue';

export default {
    name: 'UserManagement',

    components: {
        AppLayout,
        RightSidebar,
        Multiselect,
    },

    props: {
        users: {
            type: Object,
            required: true,
        },
        selectableRetailers: {
            type: Array,
            required: true,
        },
        appliedFilters: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            sidebarTitle: '',
            retailerAssignModal: false,
            currentSalesperson: null,
            selectedRetailers: [],
            rightSidebar: false,
            rightSidebarComponentName: 'CreateAdmin',
            currentPage: null,
            limit: 5,
            perPage: this.users.per_page,
            totalRows: this.users.total,
            search: null,
            mounted: false,
            disabled: false,
            activeDropdownId: null,
        };
    },

    watch: {
        search() {
            if (this.mounted) {
                this.debouncedFetchPageData();
            }
        },
    },

    created() {
        this.currentPage = this.users.current_page;
    },

    mounted() {
        this.disabled = this.users.data.length === 0;

        // document.addEventListener('click', this.handleClickOutside);

        if (this.appliedFilters.keyword) {
            this.search = this.appliedFilters.keyword;
        }

        this.debouncedFetchPageData = _.debounce(this.fetchPageData, 2000);

        this.$nextTick(() => {
            this.mounted = true;
        });
    },

    methods: {
        toggleDropdown(id) {
            console.log("toggleDropdown", id)
            this.activeDropdownId = this.activeDropdownId === id ? null : id;
            console.log("activeDropdownId", this.activeDropdownId)
        },
        // handleClickOutside(event) {
        //     // check if the click is outside the currently open dropdown container
        //     if (this.activeDropdownId !== null) {
        //         const refKey = 'dropdown-container-' + this.activeDropdownId;
        //         const container = this.$refs[refKey];

        //         // container may be an array if used in v-for
        //         const el = Array.isArray(container) ? container[0] : container;

        //         if (el && !el.contains(event.target)) {
        //             this.activeDropdownId = null;
        //         }
        //     }
        // },
        // handleDropdownAction(action) {
        //     action();
        //     this.activeDropdownId = null;
        // },

        selectableRetailersForCurrentSalesPerson() {
            if (this.currentSalesperson) {

                return this.selectableRetailers
                    .filter((retailer) => !retailer.inverse_associated_users
                        .map((associatedUsers) => associatedUsers.id)
                        .includes(this.currentSalesperson.id)
                    );
            }
            return [];
        },

        showAssignRetailersModal(user) {
            this.currentSalesperson = user;
            this.retailerAssignModal = true;
            this.selectedRetailers = this.selectableRetailers
                .filter((retailer) => retailer.inverse_associated_users
                    .map((associatedUsers) => associatedUsers.id)
                    .includes(user.id)
                );
        },

        hideAssignRetailersModal() {
            this.selectedRetailers = [];
            this.currentSalesperson = null;
            this.retailerAssignModal = false;
        },

        assignRetailers() {
            const retailerIdArray = this.selectedRetailers.map((retailer) => retailer.id);
            this.$inertia.post(
                route('users.management.salesperson.assign', this.currentSalesperson.id),
                { retailerIds: retailerIdArray },
                {
                    onSuccess: () => {
                        this.selectedRetailers = [];
                        this.currentSalesperson = null;
                        this.retailerAssignModal = false;
                    },
                }
            );
        },

        toggleRole(user) {
            let newRole = null;

            if (user.roles.find((role) => role.name === 'admin')) {
                newRole = 'superadmin';
            } else if (user.roles.find((role) => role.name === 'superadmin')) {
                newRole = 'admin';
            }
            this.$dialog
                .confirm({
                    title: 'Confirm',
                    text: `Are you sure you want to change role of this user to ${newRole}?`,
                })
                .then((result) => {
                    if (result.isOk) {
                        this.$inertia.post(route('users.management.admin.toggleRole', user.id));
                    }
                });
        },

        suspendUser(user) {
            this.$dialog
                .confirm({
                    title: 'Confirm',
                    text: 'Are you sure you want to suspend this user?',
                })
                .then((result) => {
                    if (result.isOk) {
                        this.$inertia.delete(route('users.management.admin.suspend', user.id));
                    }
                });
        },

        unsuspendUser(user) {
            this.$dialog
                .confirm({
                    title: 'Confirm',
                    text: 'Are you sure you want to activate this user?',
                })
                .then((result) => {
                    if (result.isOk) {
                        this.$inertia.post(route('users.management.admin.unsuspend', user.id));
                    }
                });
        },

        showSalesPersonDetail(user) {
            console.log(user);
            this.$inertia.get(
                route('reports.salesperson', {
                    salespersonId: user.id,
                })
            );
        },

        toggleRightSidebar(forUserType = null) {
            this.rightSidebar = !this.rightSidebar;
            if (this.rightSidebar) {
                if (forUserType === 'admin') {
                    this.rightSidebarComponentName = 'CreateAdmin';
                    this.sidebarTitle = 'Create Admin';
                } else {
                    this.rightSidebarComponentName = 'CreateSalesperson';
                    this.sidebarTitle = 'Create Salesperson';
                }
                // forUserType === 'admin' ? this.rightSidebarComponentName = 'CreateAdmin' : this.rightSidebarComponentName = 'CreateSalesperson';
            }
        },

        fetchPageData(newPage) {
            this.$inertia.get(
                route('users.management.index', {
                    page: newPage,
                    keyword: this.search,
                })
            );
        },
    },

    // beforeDestroy() {
    //     document.removeEventListener('click', this.handleClickOutside);
    // },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
